import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const BannerInnerContainer = styled("div")`
    display: flex;
    align-items: center;
    margin-left: auto;
    max-width: ${breakpoints.values.xl}px;
    justify-content: space-between;
    padding: 0 0.25rem 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0rem 2.063rem 0rem 2rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0rem 2rem 0rem 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0rem 1.25rem 0rem 2.5rem;
    }
`
